import { Contract } from 'tronweb';

import Big from '@/utils/Bigjs';

import { useContract } from './useContract';

export type TRC20Contract = Contract & {
  balanceOf: (walletAddress: string) => {
    call: () => Promise<Big>;
  };
  allowance: (
    owner: string,
    spender: string
  ) => {
    call: () => Promise<Big>;
  };
  approve: (
    spender: string,
    amount: bigint
  ) => {
    send: () => Promise<string>;
  };
};
export const useTrc20Contract = (l1ContractAddress?: string) => {
  const contract = useContract<TRC20Contract>(l1ContractAddress);

  return contract;
};
